"use client";

import { useLayoutEffect, useRef } from "react";
import { MarqueeController } from "@/components/behaviors";
import styles from "./CenteredHero.module.css";
import type { HeroLogos as HeroLogosProps } from "./CenteredHero.types";

function LogoItems({ items }: { items: HeroLogosProps["items"] }) {
  return (
    <>
      {items.map((item, i) => {
        const img = <img src={item.src} alt={item.alt} loading="lazy" />;
        return (
          <li key={i}>
            {item.href ? (
              <a href={item.href} className={styles.logoLink}>
                {img}
              </a>
            ) : (
              img
            )}
          </li>
        );
      })}
    </>
  );
}

/** Variante marquee : une fenêtre étroite, les logos défilent en boucle (pause au survol, figé en reduced-motion). */
function LogoMarquee({ items, caption, windowWidth = 440 }: HeroLogosProps) {
  const hostRef = useRef<HTMLDivElement>(null);
  useLayoutEffect(() => {
    const host = hostRef.current;
    if (!host) return;
    const controller = new MarqueeController(host, { rowSelector: "[data-marquee-row]", speed: 30 });
    return () => controller.destroy();
  }, [items]);
  return (
    <div className={styles.logoMarquee} ref={hostRef}>
      <div className={styles.logoWindow} style={{ width: windowWidth }}>
        <ul className={styles.logosList} data-marquee-row="">
          <LogoItems items={items} />
        </ul>
      </div>
      {caption ? <p className={styles.logoCaption}>{caption}</p> : null}
    </div>
  );
}

/** Bande de logos (clients, partenaires) en bas du hero. Optionnelle, deux variantes. */
export function HeroLogos(props: HeroLogosProps) {
  if (props.variant === "marquee") return <LogoMarquee {...props} />;
  return (
    <div className={styles.logos}>
      {props.label ? <span className={styles.logosLabel}>{props.label}</span> : null}
      <ul className={styles.logosList}>
        <LogoItems items={props.items} />
      </ul>
    </div>
  );
}
